import React from 'react';
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import {Typography} from '@material-ui/core';

import NoSelect from './no_select';
import ResetButton from './reset_button';


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: '100%',
  },
  noselectHeader: {
    userSelect: 'none',
  },
  energy: {
    backgroundColor: '#bfd7ea',
  },
}));

export default function PlayerArea() {
  const classes = useStyles();
  const energy = useSelector((state) => state.game.energy);
  const bestWords = useSelector((state) => state.game.bestWords);

  return (
    <Paper className={classes.paper}>
      <Box mb={3}>
        <Typography variant="h5">
          <NoSelect>
            Player Status
          </NoSelect>
        </Typography>
      </Box>
      <Box mb={3}>
        <ResetButton />
      </Box>
      <Card className={`${classes.card} ${classes.energy}`}>
        <CardHeader className={classes.noselectHeader} title="Energy" />
        <CardContent>
          <Typography variant="h5">
            <NoSelect>
              {energy}
            </NoSelect>
          </Typography>
        </CardContent>
      </Card>
      <Box mt={3}>
        <List>
          {bestWords.map((best) => (
            <ListItem key={`bwk-${best.word}`}>
              <NoSelect>
                {`${best.word} (${best.score})`}
              </NoSelect>
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
};
